import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getCovidConfigurations () {
    return Api().get("/covid-configurations");
  },
  updateCovidConfiguration (params) {
    return Api().put("/covid-configurations",params);
  },
  addCovidConfiguration (params) {
    return Api().post("/covid-configurations",params);
  },
  getCovidConfiguration (params) {
    return Api().get("/covid-configurations/"+params);
  },
  deleteCovidConfiguration (params) {
    return Api().delete("/covid-configurations/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/CovidConfigurationService.js